<template>
  <div
    class="page-container"
    ref="pageContainer"
    :class="{
      'page-container__full': isFullScreen && (isH5 || openAiMode),
      'component-container': isComponent,
    }"
  >
    <custom-player
      :lessonInfo="{
        id: Number(lessonId),
        unit_id: unitId,
        course_id: courseId,
        risk_control_switch: riskConfigSwitch,
      }"
      ref="dplayer"
      :startTime="lastProgressTime"
      :jumpPlayTime="jumpPlayTime"
      :title="lessonDetail.lesson_name || ''"
      :orgName="
        riskConfigSwitch === 1 && riskConfig.org_watermark_switch === 1
          ? lessonDetail.org_name
          : ''
      "
      :show-back="showBack"
      :fullScreenStatus="isFullScreen"
      :isShowTop="!isComponent"
      :isComponent="isComponent"
      @back="goCourseDetails"
      @toggleFullScreen="toggleFullScreen"
      @afresh="afresh"
      :openAiMode="openAiMode"
      @videoDurationChange="videoDurationChange"
      :noteComponentId="noteComponentId"
      :urlProgressTime="urlProgressTime"
    ></custom-player>
    <el-button class="enroll-btn" v-if="!isEnroll" @click="handleEnroll"
      >去报名</el-button
    >
    <div
      v-if="riskConfigSwitch === 1"
      class="watermask-container"
      :class="{ 'watermask-full-screen': isFullScreen }"
      style="pointer-events: none"
    >
      <Watermark :lessonDetail="lessonDetail" :userName="userName"></Watermark>
    </div>
    <!-- <div
      ref="watermarkBox"
      class="watermask-container"
      v-if="riskConfigSwitch === 1"
      :class="{ 'watermask-full-screen': isFullScreen }"
      style="pointer-events: none"
    >
      <div
        class="notice scrolling-notice"
        :class="{
          'hidden-notice':
            !showNotice ||
            !(
              riskConfigSwitch === 1 && riskConfig.copyright_notice_switch === 1
            ),
        }"
      >
        <p
          v-if="
            riskConfigSwitch === 1 && riskConfig.copyright_notice_switch === 1
          "
          ref="scrollingText"
          class="scroll-text"
          :class="{
            'scrolling-text__infinite':
              riskConfig.copyright_notice_switch === 1,
            'scrolling-text__once': riskConfig.copyright_notice_switch === 2,
          }"
        >
          【版权声明】本课程版权归{{
            lessonDetail.org_name
          }}所有，仅限个人学习，严禁任何形式的录制、传播和分享。
        </p>
      </div>
      <HorseRace
        class="horse-race"
        :content="userName"
        :isScroll="riskConfig.user_watermark_type === 1"
      >
      </HorseRace>
    </div> -->
  </div>
</template>
<script>
import { mapMutations, mapGetters, mapState } from "vuex";
import { isHXApp, isMobile, isH5 } from "@saas/components/src";
import {
  playbackKeepAlive,
  getLessonDetail,
} from "@saas/server-api/src/learning-center";
// import HorseRace from "@saas/components/src/components/horse-race-lamp/Index.vue";
import CustomPlayer from "./components/CustomPlayer.vue";
import { checkLesson } from "@saas/server-api/src/learning-center";
import Watermark from "./components/Watermark.vue";
export default {
  name: "Replay",
  props: {
    noteComponentId: {
      type: [String, Number],
      default: null,
    },
    openAiMode: {
      type: Boolean,
      default: false,
    },
    isComponent: {
      type: Boolean,
      default: false,
    },
    componentParams: {
      type: Object,
      default: () => {},
    },
    lessonInfo: {
      type: Object,
      default: () => {},
    },
    courseInfo: {
      type: Object,
      default: () => {},
    },
    initFullScreen: {
      type: Boolean,
      default: false,
    },
    jumpPlayTime: {
      type: Number,
      default: 0,
    },
  },
  components: {
    // HorseRace,
    CustomPlayer,
    Watermark,
  },
  data() {
    return {
      userName: "", //水印用户信息
      isMobile: isMobile(),
      isHXApp: isHXApp(),
      isH5: isH5(),
      videoList: [],
      lessonDetail: {},
      dp: null,
      currentIndex: 0,
      unitId: 0,
      lessonId: 0,
      lessonType: 0,
      courseId: 0,
      // 心跳定时器
      timerId: null,
      // 心跳延时器
      timerOutId: null,
      // 上次调用心跳接口的时间
      lastCallTime: 0,
      // 暂停剩余时间
      pauseRemainingTime: 0,
      // 是否第一次播放
      isFirstPlay: true,
      progress: 0,
      trialDuration: 0,
      startTrialDuration: 0,
      isPause: false,
      showBack: false,
      // 跑马灯还是固定展示水印
      isScroll: false,
      // 开启风险控制 1开启 2关闭
      riskConfigSwitch: 1,
      riskConfig: {},
      // 10分钟间隔
      durationTime: 10 * 60 * 1000,
      showNotice: true,
      scrollInterval: null,
      scrollTimeout: null,
      isFullScreen: false,
      isTeacher: false,
      isElectron: window.isElectron,
      // 上次播放进度
      lastProgressTime: 0,
      videoDuration: 0,
    };
  },
  computed: {
    ...mapState("replay", ["urlProgressTime"]),
    ...mapGetters(["user"]),
    // 是否报名
    isEnroll() {
      return (
        !!this.courseInfo?.enrollment ||
        (!this.isComponent && Number(this.$route.query.isEnroll))
      );
    },
  },
  mounted() {
    let params = {};
    if (this.componentParams?.lessonId) {
      params = this.componentParams;
    } else {
      params = this.$route.params;
    }
    const { courseId = 0, unitId = 0, lessonId = 0 } = params;
    this.courseId = courseId;
    this.unitId = unitId;
    this.lessonId = lessonId;
    this.checkLesson();
    this.initDplay();
    // 返回按钮展示
    if (!this.$route.query.trial) {
      this.showBack = true;
    }
    this.setUserName(this.$store.getters.user);
    //全屏监听
    document.addEventListener("fullscreenchange", (event) => {
      if (document.fullscreenElement) {
        this.isFullScreen = true;
        console.log("----------------现在是全屏------------------");
      } else {
        this.isFullScreen = false;
        console.log("----------------现在是非全屏------------------");
      }
      this.$emit("fullScreenChange", this.isFullScreen);
    });
  },
  methods: {
    ...mapMutations("replay", ["setInitNoteContent", "setUrlProgressTime"]),
    videoDurationChange(duration) {
      this.videoDuration = duration;
    },
    setUserName(newVal) {
      if (newVal) {
        this.userName = `${newVal.nickname || "-"}（${newVal.user_id || "-"}）`;
      } else {
        this.userName = ``;
      }
    },
    goCourseDetails() {
      this.$router.back();
    },
    // 心跳接口请求
    callKeepAlive(url) {
      playbackKeepAlive({
        course_id: this.courseId,
        lesson_id: +this.lessonId,
        client_type: 1,
        play_time: new Date().getTime(),
        video_url: url || this.videoList[this.currentIndex].url,
        video_progress_time: this.progress,
        video_speed: this.dp.video.playbackRate,
        video_index: this.currentIndex + 1,
      });
      this.lastCallTime = new Date().getTime();
    },
    // 定时器开始
    startTimer() {
      if (this.pauseRemainingTime > 0) {
        // 如果有暂停时剩余的时间，直接使用这个时间
        this.timerOutId = setTimeout(() => {
          this.callKeepAlive();
          this.startTimer();
        }, this.pauseRemainingTime);
        this.pauseRemainingTime = 0;
      } else {
        // 否则，每隔一分钟调用一次
        clearInterval(this.timerId);
        this.timerId = setInterval(this.callKeepAlive, 60 * 1000);
      }
    },
    // 定时器结束
    stopTimer() {
      clearInterval(this.timerId);
      clearTimeout(this.timerOutId);
      this.timerId = null;
      this.timerOutId = null;
      const now = Date.now();
      const remainingTime = 60 * 1000 - (now - this.lastCallTime);
      this.pauseRemainingTime = Math.max(0, remainingTime);
    },
    checkLesson() {
      if (!this.courseId || !this.lessonId) {
        return;
      }
      checkLesson({ course_id: this.courseId, lesson_id: this.lessonId }).then(
        (res) => {
          if (res.code === 1) {
            this.getLessonDetail();
          } else {
            this.$message.error(res.message);
          }
        }
      );
    },
    // 获取课时详情
    getLessonDetail() {
      if (!this.courseId || !this.lessonId) {
        return;
      }
      getLessonDetail({
        course_id: this.courseId,
        lesson_id: this.lessonId,
      })
        .then((res) => {
          if (res.code === 1) {
            this.lessonDetail = res.data || {};
            this.$emit("lessonInfo", this.lessonDetail);
            // this.startTrialDuration =
            //   (res.data.trial_duration || 0) * 60 -
            //   (res.data.video_progress_time || 0);
            this.trialDuration = (res.data.trial_duration || 0) * 60;
            this.lessonType = res.data.lesson_type;
            this.isTeacher = res.data.is_teacher;
            this.lastProgressTime = res.data.video_progress_time || 0;
            this.currentIndex = res.data.video_index
              ? res.data.video_index - 1
              : 0;
            this.riskConfigSwitch = res.data.risk_control_switch;
            this.riskConfig = res.data.risk_control_config || {};
            const videoUrl =
              +this.lessonType === 1
                ? this.lessonDetail.video_url || ""
                : this.lessonDetail.record_url || "";
            this.videoList = videoUrl.split(",").map((item) => {
              return {
                url: item,
              };
            });

            this.dealPlay();
            // if (this.riskConfigSwitch === 1) {
            // this.startScroll();
            // }

            let isElectron = window.isElectron ?? false;
            if (isElectron) {
              document.title = this.lessonDetail.lesson_name;
              if (window.screenCaptureSwitch) {
                window.screenCaptureSwitch({
                  isEnter: true,
                  disableRecord: res.data.risk_control_switch == 1,
                });
              }
            }
          } else if (res.code === 40000) {
            this.$message.error(res.message);
            setTimeout(() => {
              this.$router.push({ name: "myCourse" });
            }, 1500);
          } else if (res.code === 40007) {
            // 开启网页防火墙
            // this.$router.replace("/firewall/" + this.courseId);
          } else if (res.code !== 10045) {
            // 10045:未到课时发布时间
            this.$message.error(res?.message || "请求失败");
          }
        })
        .catch((err) => {
          console.log("回放页面请求课时详情失败", err);
        });
    },
    // 试学时间校验
    checkTrialDuration() {
      if (this.trialDuration <= 0) {
        return;
      }
      const duration = this.startTrialDuration + this.dp.video.currentTime;
      if (duration >= this.trialDuration) {
        if (!this.isPause) {
          if (this.lessonDetail.is_sign_up) {
            // 已报名
            this.$message.error("试学时间已到，无法继续观看");
          } else {
            this.$message.error("试学时间已到，如对课程感兴趣可立即报名");
          }
        }
        this.isPause = true;
        this.dp.pause();
        this.dp.seek(this.trialDuration - this.startTrialDuration);
      }
    },
    handleSideAndTopBar(show = false) {
      let value = "none";
      if (show) {
        value = "";
      }
      let selectors = [".side-bar", ".topbar", ".windows", ".mac-bars"];
      if (this.openAiMode) {
        selectors.push(
          ".video-slice-retryable-wrapper",
          ".ai-right-operation-component",
          ".video-player-wrap .lesson-name-wrap"
        );
      }
      selectors.forEach((item) => {
        let eleItem = document.querySelector(item);
        if (eleItem) {
          eleItem.style.display = value;
        }
      });
    },
    toggleFullScreen() {
      this.setInitNoteContent();
      const element = this.$refs.pageContainer;
      if (window.isElectron) {
        if (this.isFullScreen) {
          window.ReplyElectronApi.exitFullScreen();
          this.handleSideAndTopBar(true);
        } else {
          window.ReplyElectronApi.fullScreen();
          this.handleSideAndTopBar();
        }
        this.isFullScreen = !this.isFullScreen;
        this.$emit("fullScreenChange", this.isFullScreen);
        return;
      } else if (this.isMobile) {
        this.isFullScreen = !this.isFullScreen;
        this.$store.commit("common/setShowH5Footer", !this.isFullScreen);
        if (this.isFullScreen) {
          document.body.classList.add("replay-landscape");
        } else {
          document.body.classList.remove("replay-landscape");
        }
        return;
      } else {
        // 网页
        if (this.openAiMode) {
          if (
            !document.fullscreenElement &&
            !document.webkitIsFullScreen &&
            !document.mozFullScreen &&
            !document.msFullscreenElement
          ) {
            if (element.requestFullscreen) {
              document
                .querySelector(".web-normal-mode-fullscreen-cont")
                .requestFullscreen();
            } else if (element.msRequestFullscreen) {
              document
                .querySelector(".web-normal-mode-fullscreen-cont")
                .msRequestFullscreen();
            } else if (element.mozRequestFullScreen) {
              document
                .querySelector(".web-normal-mode-fullscreen-cont")
                .mozRequestFullScreen();
            } else if (element.webkitRequestFullscreen) {
              element.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
            }
            this.isFullScreen = true;
          } else {
            this.handleExitFullscreen();
          }
        } else {
          // 普通看课
          if (
            !document.fullscreenElement &&
            !document.webkitIsFullScreen &&
            !document.mozFullScreen &&
            !document.msFullscreenElement
          ) {
            document
              .querySelector(".web-normal-mode-fullscreen-cont")
              .requestFullscreen();
            this.isFullScreen = true;
          } else {
            this.handleExitFullscreen();
          }
        }
      }
    },
    handleExitFullscreen() {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      }
      this.isFullScreen = false;
    },
    initDplay() {
      this.dp = this.$refs.dplayer.dplayer;
      if (this.isH5 && !this.isComponent && !window.isElectron) {
        this.toggleFullScreen();
        // this.dp.fullScreen.request("web");
      }
      this.dp.on("play", () => {
        if (this.isFirstPlay) {
          this.lastCallTime = new Date().getTime();
          this.isFirstPlay = false;
        }
        if (!this.userName) {
          // this.setUserName(this.user);
          this.setUserName(this.$store.getters.user);
        }
        this.isPause = false;
        console.log(111111111111);

        if (!(this.lessonDetail.is_sign_up && this.lessonDetail.is_validity)) {
          this.checkTrialDuration();
        }
        this.startTimer();
      });
      this.dp.on("timeupdate", () => {
        this.$emit("timeupdate", this.dp.video.currentTime);
        // console.log("timeupdate", this.lessonDetail);
        // console.log(this.lessonDetail.is_sign_up);
        // console.log(this.lessonDetail.is_validity);
        // console.log(
        //   !(this.lessonDetail.is_sign_up && this.lessonDetail.is_validity)
        // );

        if (!(this.lessonDetail.is_sign_up && this.lessonDetail.is_validity)) {
          // console.log(11222222222);

          this.checkTrialDuration();
        }
        // 向上取整
        this.progress = Math.ceil(this.dp.video.currentTime);
      });

      this.dp.on("pause", () => {
        this.stopTimer();
      });
      this.dp.on("ended", () => {
        this.startTrialDuration += Math.ceil(this.dp.video.currentTime);
        // 当前视频播放完毕后

        // 如果还有下个视频，则加载并播放
        if (this.currentIndex < this.videoList.length - 1) {
          this.currentIndex++;
          this.lastProgressTime = 0;
          this.setUrlProgressTime(null);
          this.dp.switchVideo({
            url: this.videoList[this.currentIndex].url, //
          });
          this.dp.play();
        } else {
          // 如果没有更多视频了，可以执行相应操作，如提示用户等
          const index = this.currentIndex;
          this.callKeepAlive(this.videoList[index].url);
          this.stopTimer();
        }
      });
      // this.dp.on("fullscreen", () => {
      //   // 不会走这里了，因为隐藏了浏览器全屏按钮
      //   this.dp.fullScreen.cancel("browser");
      //   this.dp.fullScreen.request("web");
      // });
      this.dp.on("loadeddata", () => {
        console.log("loadeddata");
      });
      this.dp.on("webfullscreen", () => {
        if (this.isMobile) {
          document.body.classList.add("replay-landscape");
        }
        if (this.$refs["watermarkBox"]) {
          const width = this.$refs["dplayer"].clientWidth;
          const height = this.$refs["dplayer"].clientHeight;
          this.$refs["watermarkBox"].style.width = width + "px";
          this.$refs["watermarkBox"].style.height = height - 200 + "px";
        }
        this.isFullScreen = true;
        if (window.isElectron) {
          let elTopBar = document.querySelector(".topbar");
          if (elTopBar) {
            elTopBar.style.display = "none";
          }
        }
        let navBarEle = document.querySelector(".nav-bar");
        if (navBarEle) {
          navBarEle.style.display = "none";
        }
        let footerEle = document.querySelector(".footer");
        if (footerEle) {
          footerEle.style.display = "none";
        }
      });
      this.dp.on("webfullscreen_cancel", () => {
        this.exitFullscreen();
        this.isFullScreen = false;
        // 删除inline style
        if (this.$refs["watermarkBox"]) {
          this.$refs["watermarkBox"].style.width = "";
          this.$refs["watermarkBox"].style.height = "";
        }
      });
    },
    // 跳转
    jumpTime(time) {
      this.dp.seek(time);
      this.dp.play();
    },
    // 从头学
    afresh() {
      this.currentIndex = 0;
      this.lastProgressTime = 0;
      this.startTrialDuration = 0;
      this.setUrlProgressTime(null);
      this.dp.switchVideo({
        url: this.videoList[this.currentIndex]?.url || "",
      });
      this.dp.play();
    },
    // 处理视频播放
    dealPlay() {
      this.dp.switchVideo({
        url: this.videoList[this.currentIndex]?.url || "",
      });
    },
    exitFullscreen() {
      if (this.isMobile) {
        document.body.classList.remove("replay-landscape");
      }
      if (window.isElectron) {
        let elTopBar = document.querySelector(".topbar");
        if (elTopBar) {
          elTopBar.removeAttribute("style");
        }
      }
      let navBarEle = document.querySelector(".nav-bar");
      if (navBarEle) {
        navBarEle.style.display = "block";
      }
      let footerEle = document.querySelector(".footer");
      if (footerEle) {
        footerEle.style.display = "block";
      }
    },
    // 滚动公告
    // startScroll() {
    //   this.showNotice = true;
    //   if (this.riskConfig.copyright_notice_type === 1) {
    //     // 间隔10分钟滚动一次
    //     this.scrollOnce();
    //     this.scrollInterval = setInterval(() => {
    //       this.showNotice = true;
    //       this.scrollOnce();
    //     }, this.durationTime);
    //   } else {
    //     // 无限滚动
    //     this.scrollInfinite();
    //   }
    // },
    // 停止滚动
    // stopScroll() {
    //   clearInterval(this.scrollInterval);
    //   this.showNotice = false;
    // },
    // 单次滚动
    // scrollOnce() {
    //   this.$nextTick(() => {
    //     // 实现单次滚动的逻辑，例如使用transform等CSS动画
    //     // 这里仅作为示意，具体实现取决于你的滚动效果
    //     if (this.$refs.scrollingText) {
    //       this.$refs.scrollingText.classList.remove("scrolling-text__infinite");
    //       this.$refs.scrollingText.classList.add("scrolling-text__once");
    //       const time = this.adjustAnimationDuration(".scrolling-text__once");
    //       this.scrollTimeout = setTimeout(() => {
    //         this.$refs.scrollingText.classList.remove("scrolling-text__once");
    //         this.showNotice = false;
    //       }, time * 1000); //
    //     }
    //   });
    // },
    // 无限滚动
    // scrollInfinite() {
    //   this.$nextTick(() => {
    //     // 无限滚动的逻辑，可以通过CSS动画实现
    //     if (this.$refs.scrollingText) {
    //       this.$refs.scrollingText.classList.remove("scrolling-text__once");
    //       this.$refs.scrollingText.classList.add("scrolling-text__infinite");
    //       this.adjustAnimationDuration(".scrolling-text__infinite");
    //     }
    //   });
    // },
    // JavaScript
    // adjustAnimationDuration(className) {
    //   const screenWidth = window.innerWidth;
    //   const scrollContent = document.querySelector(className);
    //   scrollContent.style.animationDuration =
    //     (screenWidth / 60).toFixed(2) + "s";
    //   return (screenWidth / 60).toFixed(2) + 5;
    // },
    // 非全屏时，在新标签页打开课程的商品详情页
    // 全屏时，变为非全屏，再在新标签页打开课程的商品详情页
    handleEnroll() {
      if (window.isElectron || this.isMobile) {
        if (window.ReplyElectronApi) {
          // 视频播放页
          window.ReplyElectronApi.mainWinJumpUrl({
            name: "ProductDetails",
            params: {
              id: this.courseId,
            },
          });
        } else {
          this.$router.push(`/product-detail/${this.courseId}`);
        }
      } else {
        window.open(`/product-detail/${this.courseId}`);
      }
    },
  },
  watch: {
    initFullScreen: {
      handler: function (newVal) {
        this.isFullScreen = newVal;
      },
      immediate: true,
    },
    user: {
      handler: function (newVal) {
        console.log("user", newVal);
        // this.setUserName(newVal);
      },
      immediate: true,
      deep: true,
    },
    componentParams: {
      handler: function (newVal, oldVal) {
        console.log("componentParams", newVal);
        console.log("componentParams>>>>", oldVal);
        if (!newVal) return;
        const { courseId, unitId, lessonId } = newVal;
        this.courseId = courseId;
        this.unitId = unitId;
        this.lessonId = lessonId;
        // this.getLessonDetail();
        this.checkLesson();
        this.initDplay();
        // 返回按钮展示
        if (!this.$route.query.trial) {
          this.showBack = true;
        }
        this.setUserName(this.$store.getters.user);
      },
      deep: true,
    },
    isFullScreen: {
      handler: function (newVal) {
        this.$emit("changeFullScreen", newVal);
      },
      immediate: true,
    },
  },
  beforeDestroy() {
    // 访录屏
    if (window.screenCaptureSwitch) {
      window.screenCaptureSwitch({
        isEnter: false,
        disableRecord: false,
      });
    }
    clearInterval(this.timerId);
    clearTimeout(this.timerOutId);
    this.exitFullscreen();
    this.dp.fullScreen.cancel("web");
  },
  destroyed() {},
};
</script>
<style lang="scss" scoped>
.page-container {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  position: relative;
  background: #141818;
  // #dplayer ::v-deep {
  //   width: 100%;
  //   height: auto;
  //   .dplayer-play-icon {
  //     display: inline-block;
  //   }
  // }
  .handle-box {
    position: absolute;
    height: 200px;
    width: 100%;
    z-index: 1;
    // display: flex;
    // justify-content: space-between;
    // align-items: center;
    // text-align: center;
    background: linear-gradient(
      0,
      rgba(13, 15, 20, 0) 0%,
      rgba(13, 15, 20, 0.9) 100%
    );
    .back-wrap {
      position: absolute;
      left: 62px;
      top: 60px;
      z-index: 1000;
      .back-btn {
        font-size: 20px;
        cursor: pointer;
        color: rgba(42, 177, 138, 1);
        display: flex;
        align-items: center;
        flex-direction: row;
        justify-content: flex-start;
        img {
          width: 24px;
          height: 24px;
          margin-right: 6px;
        }
      }
    }
    .name {
      color: #fff;
      font-weight: 500;
      font-size: 20px;
      color: #ffffff;
      width: 100%;
      margin-top: 60px;
      padding: 0 180px;
      line-height: 28px;
      text-align: center;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}
.component-container {
  // height: auto;
  height: 100%;
}
.org-watermask {
  padding-left: 20px;
  color: #eee;
  opacity: 0.5;
  height: 50px;
  div {
    padding-top: 20px;
    font-size: 20px;
  }
}
.watermask-container {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  z-index: 1000;
}
.horse-race {
  width: 100%;
  height: 70%;
}
.scrolling-notice {
  background: rgba($color: #333, $alpha: 0.2);
  color: #fff;
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  height: 28px;
  line-height: 28px;
  .scroll-text {
    transform: translateX(100%);
    min-width: 100%;
  }

  .scrolling-text__infinite {
    display: inline-block;
    animation: scroll-left 15s linear infinite;
  }
  .scrolling-text__once {
    display: inline-block;
    animation: scroll-left 15s linear alternate forwards;
  }
}
.hidden-notice {
  opacity: 0;
}
.enroll-btn {
  position: absolute;
  right: 30px;
  top: 30px;
  padding: 0;
  width: 90px;
  height: 40px;
  border: none;
  background: linear-gradient(135deg, #ff7a00 0%, #ff27c0 100%);
  border-radius: 10px;
  font-size: 16px;
  color: #fff;
  z-index: 1000;
}
@keyframes scroll-left {
  0% {
    transform: translateX(100%);
  }

  100% {
    transform: translateX(-100%);
  }
}
@media (max-width: 767px) {
  .page-container {
    width: auto;
    #dplayer {
      width: 100%;
    }
    .handle-box {
      width: 100%;
      height: 0.9333rem;
      .name {
        font-size: 0.3rem;
        padding: 0 2.1rem;
      }
      .back-wrap {
        left: 0.5333rem;
        top: 50%;
        transform: translateY(-50%);
        z-index: 1000;
        .back-btn {
          cursor: pointer;
          font-size: 0.3rem;
          img {
            width: 0.3rem;
            height: 0.3rem;
            margin-right: 6px;
          }
        }
      }
    }
    .watermask-container {
      position: absolute;
      width: calc(100% - 0.54rem);
      height: 5rem;
      left: 0;
      top: 0;
      .scrolling-notice {
        height: 0.3733rem;
        line-height: 0.3733rem;
        font-size: 0.2133rem;
      }
    }
    .org-watermask {
      padding-left: 0.4rem;
      font-size: 0.2rem;
      height: 0.5rem;
      div {
        padding-top: 0;
        font-size: 0.3rem;
      }
    }
  }
}

.page-container__full {
  position: fixed;
  left: 0;
  top: 0;
  padding: 0;
  .watermask-full-screen {
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 100000000;
    ::v-deep .watermask-container {
      width: 100%;
    }
  }
}

// electron-视频播放页
.page-container:not(.component-container) {
  .enroll-btn {
    top: 60px;
    z-index: 9999999;
    -webkit-app-region: none;
  }
}
</style>
<style lang="scss">
.web-fullscreen-player {
  .dplayer-full-icon {
    display: none !important;
  }
  .dplayer-controller .dplayer-icons .dplayer-full .dplayer-full-in-icon {
    position: static;
    display: inline-block !important;
  }
}
</style>
<style lang="scss">
.replay-landscape {
  width: 100vh;
  height: 100vw;
  overflow: hidden;
  transform-origin: top left;
  transform: rotate(90deg) translateY(-100%);
  transition: all 0.3s;
  .tabs-container {
    display: none !important;
  }
  .course-info-area {
    display: none !important;
  }
}
</style>
